import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { notification } from "antd";
import Signin from "./Signin/Signin";
import { useAuth } from "../../provider/Auth.provider";
import { findUserByUID } from "../../service/findUsers/findUserByUID";
import Dashboard from "./Dashboard/Dashboard";

const SuperAdmin = () => {
  const { user, loading } = useAuth();
  const [isSignedIn, setIsSignedIn] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!user) return;
    const checkUserAccess = async () => {
      try {
        if (!user?.uid) {
          setIsSignedIn(false);
          return;
        }
        const userDetails = await findUserByUID(user.uid);
        if (userDetails?.userTypes === "super_admin") {
          setIsSignedIn(true);
          if (location.pathname !== "/superadmin/dashboard") {
            navigate("/superadmin/dashboard", { replace: true });
          }
          return;
        }
      } catch (error) {
        notification.error({
          message: "Error",
          description: "An error occurred while checking user access",
          placement: "topRight",
          duration: 3,
        });
        setIsSignedIn(false);
      }
    };

    checkUserAccess();
  }, [user, navigate, location]);

  if (loading) {
    return <p>Loading...</p>;
  }

  return <>{!isSignedIn ? <Signin /> : <Dashboard />}</>;
};

export default SuperAdmin;
